import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const SubtractIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="14"
        ref={forwardedRef}
        role="img"
        viewBox="0 0 14 14"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path clipRule="evenodd" d="M12 8H2V6H12V8Z" fill={color} fillRule="evenodd" />
      </svg>
    );
  },
);

export default SubtractIcon;
